import React from 'react';
import Zoom from '../../components/zoom/zoom';

import { useDispatch, useSelector } from 'react-redux';
import {
  galleryZoomStepSet,
  getAllGalleryImagesHigh,
  getAllGalleryImagesMid,
  getGalleryZoomStep,
} from '../../store/gallery-slice';
import { useMediaQuery } from '@mui/material';

type PropTypes = {
  image: {
    url: string;
    id: string;
  };
};

export default function ImageViewer(props: PropTypes) {
  const { image } = props;

  const zoomStep = useSelector(getGalleryZoomStep);

  const dispatch = useDispatch();

  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  // Get High quality gallery images
  const { interiorGalleryHigh, exteriorGalleryHigh } = useSelector(
    getAllGalleryImagesHigh,
  );

  // Get Mid quality gallery images
  const { interiorGalleryMid, exteriorGalleryMid } = useSelector(
    getAllGalleryImagesMid,
  );

  // Combine interior and exterior gallery images High quality
  const allGalleryHigh = React.useMemo(
    () => [...interiorGalleryHigh, ...exteriorGalleryHigh],
    [interiorGalleryHigh, exteriorGalleryHigh],
  );

  // Combine interior and exterior gallery images Mid quality
  const allGalleryMid = React.useMemo(
    () => [...interiorGalleryMid, ...exteriorGalleryMid],
    [interiorGalleryMid, exteriorGalleryMid],
  );

  const highQualityImage = allGalleryHigh.find((img) => img?.id === image?.id);

  const midQualityImage = allGalleryMid.find((img) => img?.id === image?.id);

  return (
    <Zoom
      fullscreen={zoomStep === 2}
      initialScale={1}
      objectFit="contain"
      onFullscreen={() => dispatch(galleryZoomStepSet(2))}
      section={'gallery'}
      zoomStep={zoomStep}
    >
      <img
        alt="image"
        src={
          zoomStep === 1
            ? image?.url
            : isMobile
            ? midQualityImage?.url
            : highQualityImage?.url
        }
      />
    </Zoom>
  );
}
